<div class="page">
  <span class="loader"></span>

</div>
